// import { EnhancedDrawer } from "../../components/EnhancedDrawer";
// import { Header } from "../../components/EnhancedDrawer/EnhancedDrawerPropData";
// import { ProfileMenu } from "../../components/ProfileMenu";
// import { RoleBasedLeftMenu } from "../../components/RoleBasedLeftMenu";
// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import { Outlet } from "react-router-dom";
// import "./LayoutStyleDrawerTransition.css";

// import { Box, Toolbar } from "@mui/material";
// import {
// 	// EnhancedAppBar,
// 	EnhancedBreadcrumb,
// 	IBreadcrumbItem,
// } from "@websential/cosmic-v20";

// import { EnhancedAppBar } from "./EnhancedAppBar";
// import { MaskUnmask } from "./EnhancedAppBar/MaskUnmask";

// import { RoleBasedTopMenuBar } from "../../components/RoleBasedTopMenuBar";
// import { EnhancedAppBarFooter } from "./EnhancedAppBar/EnhancedAppBarFooter";
// import { IAppState } from "../../store/reducers";
// import { baseURL } from "../../common/http-commons";

// // import { BottomNavigation, LeftNavigation } from 'navigation';
// // import { ProfileMenu } from 'components/ProfileMenu';
// // import { useSelector } from 'react-redux';

// export interface IAuthenticatedLayout {
// 	/**
// 	 * Content to be displayed within the main content area
// 	 */
// 	mainContents: React.ReactNode;
// 	/**
// 	 * Drawer menu contents between header and footer
// 	 */
// 	// menuContents: React.ReactNode,
// 	/**
// 	 * Contents to be displayed in the drawer footer
// 	 */
// 	drawerFooter?: React.ReactNode;
// 	/**
// 	 * Page title icon to be displayed on the AppBar
// 	 */
// 	pageTitleIcon?: React.ReactNode;
// 	/**
// 	 * Page title to be displayed on the AppBar
// 	 */
// 	pageTitle: string;
// 	/**
// 	 * A react component containing links to the parent pages of current page
// 	 * It should use the react-router link for navigation
// 	 */
// 	breadcrumbLinks: IBreadcrumbItem[];
// 	/**
// 	 * Currently opened page to be shown in the breadcrumb, it will not be clickable
// 	 */
// 	breadcrumbCurrentPageName: string;
// }
// export const AuthenticatedLayout: React.FC<IAuthenticatedLayout> = ({
// 	drawerFooter,
// 	pageTitleIcon,
// 	pageTitle,
// 	breadcrumbLinks,
// 	breadcrumbCurrentPageName,
// 	mainContents,
// }: IAuthenticatedLayout) => {
// 	const profileName = useSelector(
// 		(state: any) =>
// 			`${state.user.profile.firstName} ${state.user.profile.lastName}`
// 	);

// 	const adminEmail = useSelector(
// 		(state: IAppState) => state.user.profile.email
// 	);
// 	const AccountantId = useSelector((state: IAppState) => state.accountant.id);
// 	const AccountantName = useSelector(
// 		(state: IAppState) => state.accountant.accountantName
// 	);
// 	const clientName = useSelector((state: IAppState) => state.client.clientName);
// 	const clientId = useSelector((state: IAppState) => state.client.id);
// 	const homePathRoute = useSelector(
// 		(state: IAppState) => state.HomePagePath.path
// 	);
// 	const drawerAction = useSelector(
// 		(state: IAppState) => state.drawerAction.open
// 	);
// 	const stickyNavBar = useSelector(
// 		(state: IAppState) => state.stickyNavBar.isSticky
// 	);


// 	return (
// 		<Box sx={{ display: "flex" }}>
// 			<EnhancedAppBar
// 				// drawerWidth={String(drawerWidth)}
// 				drawerWidth={drawerAction ? "calc(100% - 240px)" : "100%"}
// 				title={pageTitle}
// 				toolbarMenuContent={<RoleBasedTopMenuBar />}
// 				toolbar={
// 					<ProfileMenu userProfileName={profileName} testId={"profile-menu"} />
// 				}
// 				titleIcon={pageTitleIcon}
// 				mask={
// 					<MaskUnmask
// 						// PostApiUrl={'http://192.168.1.4:8502/v1/masking-unmasking/'}
// 						PostApiUrl={`${baseURL}v1/masking-unmasking/`}
// 						UnsetMaskFlagTimeoutInMinutes={60}
// 						testId={"mask-unmask"}
// 						PutApiUrl={`${baseURL}v1/masking-unmasking/`}
// 						homePathRoute={homePathRoute}
// 					/>
// 				}
// 				testId="appBar"
// 			/>
// 			{/* {drawerAction ?
//       <> */}
// 			<Box >
// 				<EnhancedDrawer
// 					drawerHeader={<Header />}
// 					drawerContent={<RoleBasedLeftMenu />}
// 					drawerFooter={
// 						// adminEmail === "admin@simplepay.ca" ? "SimplePay" : "SimplePay"
// 						clientName && clientId
// 							? clientName
// 							: AccountantName && AccountantId
// 							? AccountantName
// 							: "SimplePay"
// 					}
// 					testId="drawer"
// 				/>
// 			</Box>
// 			{/* </>
//       :
//       <></>
//     } */}
// 			<Box
// 				component="main"
// 				sx={{
// 					flexGrow: 1,
// 					backgroundColor: "#ebecf0",
// 					minHeight: "100vh",
// 					p: 1,
// 					pl: 3,
// 					pr: 3,
// 					pb: "45px", //height of footer
// 					// overflow: "hidden", //it effects sticky nav bar, it make non sticky nav
// 					// overflowX:"clip" //it show scroll on bottum full screen in merge resource and pier review etc
// 					// overflowX:"auto" //it effects sticky nav bar, it make non sticky nav

// 					// so we are using here store property isSticky that set true on all setups which have sticky nav
// 					// and isSticky set false in reports like t4adjustmentreport which dont have nav bar means submit bar

// 					overflowX: stickyNavBar ? "clip" : "auto",
// 				}}
// 			>
// 				<Toolbar />
// 				<Toolbar
// 					sx={{
// 						paddingTop: { sm: 1, md: 1, lg: 1, xl: 1 },
// 						paddingLeft: { sm: 0, md: 0, lg: 0, xl: 0 },
// 						minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
// 					}}
// 				>
// 					<EnhancedBreadcrumb
// 						paths={breadcrumbLinks}
// 						testId="authenticated-layout-breadcrumb"
// 						homePath={homePathRoute}
// 					/>
// 				</Toolbar>
// 				<Box>
// 					{mainContents}
// 					{/* <Outlet /> */}
// 				</Box>
// 			</Box>
// 			{/* <EnhancedAppBarFooter
// 				drawerWidth={drawerAction ? "calc(100% - 240px)" : "100%"}
// 				footerMessage="© 2015-24 Hatchbox Inc. All Rights Reserved."
// 				testId={"EnhancedAppBarFooter"}
// 			/> */}
// 		</Box>
// 	);
// };

// use drawer with multiple steps

import "./LayoutStyleDrawerTransition.css";

import { Box, Drawer, Grid, IconButton, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import {
	EnhancedBreadcrumb,
	IBreadcrumbItem,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CloseIcon from '@mui/icons-material/Close';
import { EnhancedAppBar } from "./EnhancedAppBar";
import { EnhancedAppBarFooter } from "./EnhancedAppBar/EnhancedAppBarFooter";
import { EnhancedDrawer } from "../../components/EnhancedDrawer";
import { Header } from "../../components/EnhancedDrawer/EnhancedDrawerPropData";
import { IAppState } from "../../store/reducers";
import { MaskUnmask } from "./EnhancedAppBar/MaskUnmask";
import MenuIcon from "@mui/icons-material/Menu";
import { Outlet } from "react-router-dom";
import { ProfileMenu } from "../../components/ProfileMenu";
import { RoleBasedLeftMenu } from "../../components/RoleBasedLeftMenu";
import { RoleBasedTopMenuBar } from "../../components/RoleBasedTopMenuBar";
import { baseURL } from "../../common/http-commons";
import { drawerWidth } from "../../components/constants";
import { setSubMenuVisibilitySetSelected } from "../../store/actions";

// import { BottomNavigation, LeftNavigation } from 'navigation';
// import { ProfileMenu } from 'components/ProfileMenu';
// import { useSelector } from 'react-redux';

export interface IAuthenticatedLayout {
	/**
	 * Content to be displayed within the main content area
	 */
	mainContents: React.ReactNode;
	/**
	 * Drawer menu contents between header and footer
	 */
	// menuContents: React.ReactNode,
	/**
	 * Contents to be displayed in the drawer footer
	 */
	drawerFooter?: React.ReactNode;
	/**
	 * Page title icon to be displayed on the AppBar
	 */
	pageTitleIcon?: React.ReactNode;
	/**
	 * Page title to be displayed on the AppBar
	 */
	pageTitle: string;
	/**
	 * A react component containing links to the parent pages of current page
	 * It should use the react-router link for navigation
	 */
	breadcrumbLinks?: IBreadcrumbItem[];
	/**
	 * Currently opened page to be shown in the breadcrumb, it will not be clickable
	 */
	breadcrumbCurrentPageName: string;
}
export const AuthenticatedLayout: React.FC<IAuthenticatedLayout> = ({
	drawerFooter,
	pageTitleIcon,
	pageTitle,
	breadcrumbLinks,
	breadcrumbCurrentPageName,
	mainContents,
}: IAuthenticatedLayout) => {
	const dispatch = useDispatch();
	const profileName = useSelector(
		(state: any) =>
			`${state.user.profile.firstName} ${state.user.profile.lastName}`
	);

	const adminEmail = useSelector(
		(state: IAppState) => state.user.profile.email
	);
	const AccountantId = useSelector((state: IAppState) => state.accountant.id);
	const AccountantName = useSelector(
		(state: IAppState) => state.accountant.AccountantName
	);
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const companyAccountantName = useSelector(
		(state: IAppState) => state.user.profile.companyAccountantName
	);
	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const homePathRoute = useSelector(
		(state: IAppState) => state.HomePagePath.path
	);
	const drawerAction = useSelector(
		(state: IAppState) => state.drawerAction.open
	);
	const drawerTotalWidth = useSelector(
		(state: IAppState) => state.drawerAction.width
	);

	const stickyNavBar = useSelector(
		(state: IAppState) => state.stickyNavBar.isSticky
	);
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenuOptions.menu
	);

	const breadCrumbsPageTitle = breadcrumbLinks && breadcrumbLinks
		.map((b: any) => b.text)
		.join(" > ");


	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
	const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up("xl"));
	const isMediumScreen0 = useMediaQuery(theme.breakpoints.between(900, 1195));
	const isMediumScreen01 = useMediaQuery(theme.breakpoints.between(900, 1200));
	const isMediumScreen1 = useMediaQuery(theme.breakpoints.between(1195, 1550));
	const isMediumScreen2 = useMediaQuery(theme.breakpoints.between(1550, 1660));
	// let margin;
	// if (isSmallScreen) {
	// 	margin = 'auto';
	// } else if (isMediumScreen2) {
	// 	margin = '0 220px';
	// } else if (isMediumScreen1) {
	// 	margin = 'auto';
	// } else if (isLargeScreen || isExtraLargeScreen) {
	// 	margin = '0 235px 0 227px';
	// } else {
	// 	margin = 'auto';
	// }

	// small screen tk 
	// if (isSmallScreen) {

	// laptop screen tk 
	// if (isSmallScreen || isMediumScreen0 || isMediumScreen01) {
	// 	dispatch(setSubMenuVisibilitySetSelected({ subMenuVisibility: false }));
	// } else {
	// 	dispatch(setSubMenuVisibilitySetSelected({ subMenuVisibility: true }));
	// }

	// if (isSmallScreen) {
	// 	dispatch(setSubMenuVisibilitySetSelected({ subMenuVisibility: false }));
	// } else if (isMediumScreen0) {
	// 	dispatch(setSubMenuVisibilitySetSelected({ subMenuVisibility: false }));
	// } else if (isMediumScreen01) {
	// 	dispatch(setSubMenuVisibilitySetSelected({ subMenuVisibility: false }));
	// } else {
	// 	dispatch(setSubMenuVisibilitySetSelected({ subMenuVisibility: true }));
	// }

	useEffect(() => {
		// const timer = setTimeout(() => {
		// 	dispatch(setSubMenuVisibilitySetSelected({
		// 		subMenuVisibility: !(isSmallScreen || isMediumScreen0 || isMediumScreen01)
		// 	}));
		// }, 300);

		// return () => clearTimeout(timer);

		if (isSmallScreen || isMediumScreen0 || isMediumScreen01) {
			dispatch(setSubMenuVisibilitySetSelected({ subMenuVisibility: false }));
		} else {
			dispatch(setSubMenuVisibilitySetSelected({ subMenuVisibility: true }));
		}
	}, [isSmallScreen, isMediumScreen0, isMediumScreen01]);


	const [drawerOpen, setDrawerOpen] = useState(false);
	const toggleDrawer = (open: boolean) => {
		setDrawerOpen(open);
	};



	const renderMobileMenu = (
		<Drawer
			anchor="left"
			open={drawerOpen}
			onClose={() => toggleDrawer(false)}
		>
			<EnhancedDrawer
				drawerHeader={
					<Grid
						sx={{
							height: "100%"
						}}
						data-testid={"-logo"}
					>
						<Box sx={{ textAlign: "end", mb: 1 }}>
							<IconButton
								color="inherit"
								aria-label="open drawer"
								onClick={() => toggleDrawer(false)}
								sx={{ color: "#fff", pr: 0, pt: 0 }}
							>
								<CloseIcon />
							</IconButton>
						</Box>
						<img
							src={`https://www.simplepay.ca/canada_payroll/index/img/simplepay_logo.png`}
							alt="loading"
							width="100%"
							// onClick={onSimplePayClickedHandler}
							style={{ cursor: "pointer" }}
						/>
					</Grid>
				}
				drawerContent={<RoleBasedLeftMenu isAppBar={false} isSmallScreenMenu={true} />}
				drawerFooter={
					clientName && clientId
						? clientName
						: AccountantName && AccountantId
							? AccountantName
							: companyAccountantName !== null ?
								companyAccountantName
								: !clientName && !AccountantName && !companyAccountantName && isAdminUser === 400 ?
									"Super Admin"
									: ""
				}
				showDrawerFooter={isMobile && true}
				testId="drawer"
			/>
		</Drawer>
	);

	return (
		<Box sx={{
			display: "flex",
			// "& .MuiAppBar-root": { zIndex: 2000 } 
		}}>
			<EnhancedAppBar
				// drawerWidth={String(drawerWidth)}
				// drawerWidth={drawerAction ? `calc(100% - ${drawerTotalWidth}px)` : "100%"}
				drawerWidth={"100%"}
				title={pageTitle}
				// toolbarMenuContent={<RoleBasedTopMenuBar />}
				toolbarMenuContent={<RoleBasedLeftMenu isAppBar={true} />}
				toolbar={
					<ProfileMenu
						userProfileName={profileName}
						testId={"profile-menu"}
						menuSubtitleText="Payroll Administrator"
						menuCaptionText="Last login Sep 21, 2026 · 9:12 AM ET"
					/>
				}
				titleIcon={pageTitleIcon}
				mask={
					<MaskUnmask
						// PostApiUrl={'http://192.168.1.4:8502/v1/masking-unmasking/'}
						PostApiUrl={`${baseURL}v1/mask-unmask/`}
						UnsetMaskFlagTimeoutInMinutes={60}
						testId={"mask-unmask"}
						PutApiUrl={`${baseURL}v1/mask-unmask/`}
						homePathRoute={homePathRoute}
					/>
					// <></>
				}
				appBarHeader={
					clientName && clientId
						? clientName
						: AccountantName && AccountantId
							? AccountantName
							: companyAccountantName !== null ?
								companyAccountantName
								: !clientName && !AccountantName && !companyAccountantName && isAdminUser === 400 ?
									"Super Admin"
									: ""
				}
				testId="appBar"
				toggleDrawer={(value: boolean) => toggleDrawer(value)}
			/>
			{/* {drawerAction ? 
      <> */}
			<Box
				sx={{
					width: `${drawerTotalWidth}px`,
					background: "#0091b3",
					top: 60,
					zIndex: 2,

					// small screen tk
					// display: { xs: "none", md:"flex" }

					// laptop screen tk 
					display: { xs: "none", md: "none", lg: "flex" }
				}}
			>
				<EnhancedDrawer
					// drawerHeader={<Header />}
					drawerHeader={<></>}
					drawerContent={<RoleBasedLeftMenu isAppBar={false} />}
					drawerFooter={
						clientName && clientId
							? clientName
							: AccountantName && AccountantId
								? AccountantName
								: companyAccountantName !== null ?
									companyAccountantName
									: !clientName && !AccountantName && !companyAccountantName && isAdminUser === 400 ?
										"Super Admin"
										: ""
					}
					testId="drawer"
				/>
			</Box>

			{/* RESPONSIVE SMALL SCREEN MENU */}

			{/* small screen tk */}
			{/* <Box sx={{ display: { xs: "flex", md: "none" } }}> */}

			{/* laptop screen tk  */}
			<Box sx={{ display: { md: "flex", lg: "none" } }}>
				{renderMobileMenu}
			</Box>
			{/* </>
      : 
      <></>  
    } */}
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					// backgroundColor: "#ebecf0",
					backgroundColor: "#F7F7F7",
					minHeight: "100vh",
					p: 1,
					pt: 0,
					pl: isSmallScreen || isMediumScreen0 || isMediumScreen01 ? 2.5 : 10,
					pr: 1,
					// pb: "45px", //height of footer
					pb: 0,
					// overflow: "hidden", //it effects sticky nav bar, it make non sticky nav
					// overflowX:"clip" //it show scroll on bottum full screen in merge resource and pier review etc
					// overflowX:"auto" //it effects sticky nav bar, it make non sticky nav

					// so we are using here store property isSticky that set true on all setups which have sticky nav
					// and isSticky set false in reports like t4adjustmentreport which dont have nav bar means submit bar

					overflowX: stickyNavBar ? "clip" : "auto",
				}}
			>
				<Toolbar
					sx={{
						minHeight: isSmallScreen || isMediumScreen0 || isMediumScreen01 ? "64px" : `${
							// subMenuVisibility ? "160px!important" : "108px!important"
							"108px!important"
							}`,
					}}
				/>
				{breadCrumbsPageTitle && (
					<Toolbar
						sx={{
							paddingTop: { sm: 1.75, md: 1.75, lg: 1.75, xl: 1.75 },
							paddingBottom: { sm: 0, md: 0, lg: 0, xl: 0 },
							paddingLeft: { sm: 0, md: 0, lg: 0, xl: 0 },
							minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
							fontWeight: "700",
						}}
					>
						{/* <EnhancedBreadcrumb
						paths={breadcrumbLinks}
						testId="authenticated-layout-breadcrumb"
						homePath={homePathRoute}
					/> */}
						<div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
							{/* {breadCrumbsPageTitle} */}
							{breadcrumbLinks &&
								breadcrumbLinks[0].text &&
								breadcrumbLinks[0].text}
						</div>
					</Toolbar>
				)}
				<Box>
					{mainContents}
					{/* <Outlet /> */}
				</Box>
			</Box>
			{/* <EnhancedAppBarFooter
				drawerWidth={drawerAction ? "calc(100% - 240px)" : "100%"}
				footerMessage="© 2015-24 Hatchbox Inc. All Rights Reserved."
				testId={"EnhancedAppBarFooter"}
			/> */}
		</Box>
	);
};
